import { useEffect, useState } from "react";
import { Spin } from "antd";
import { SwapOutlined } from "@ant-design/icons";
import { useBannerContext } from "../../context/BannerContext/BannerContext";
import { BannerListItem } from "../../context/BannerContext/constants";
import {
	Container,
	HeaderComponent,
	BannerItem,
	BannerLabel,
	SwapButton,
	ActionButtonComponent,
} from "./styles";
import MainButtonComponent from "../../components/MainButtonComponent";


const OrderBanner = () => {
	const { getBannerList, bannerList, operationStatus, updateBannerOrders } = useBannerContext();
	const [orderedList, setOrderedList] = useState<BannerListItem[]>([]);

	useEffect(() => {
		getBannerList();
	}, []);

	useEffect(() => {
		if (bannerList && bannerList.length > 0) {
			const sorted = [...bannerList].sort(
				(a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
			);
			setOrderedList(sorted);
		}
	}, [bannerList]);

	const handleSwap = (index: number) => {
		if (index >= orderedList.length - 1) return;
		const newList = [...orderedList];
		const temp = newList[index];
		newList[index] = newList[index + 1];
		newList[index + 1] = temp;
		setOrderedList(newList);
	};

	const handleSave = async () => {
		updateBannerOrders(orderedList);
	};

	return (
		<Container>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<HeaderComponent>Banner Sıralama</HeaderComponent>
				{orderedList.map((banner, index) => (
					<BannerItem key={banner.bannerId}>
						<BannerLabel>
							{index + 1} - {banner.headerName}
						</BannerLabel>
						<SwapButton
							onClick={() => handleSwap(index)}
							disabled={index >= orderedList.length - 1}
							title="Aşağıdaki banner ile değiştir"
						>
							<SwapOutlined />
						</SwapButton>
					</BannerItem>
				))}
				<ActionButtonComponent>
					<MainButtonComponent type="default" onClick={handleSave} loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
						Kaydet
					</MainButtonComponent>
				</ActionButtonComponent>
			</Spin>
		</Container>
	);
};

export default OrderBanner;
